
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { required } from 'vee-validate/dist/rules';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { ILeagueTaskCreate, ILeagueTaskUpdate } from '@/interfaces/league';
import { leagueTaskStore } from '@/store';
import { isValid, parseISO } from 'date-fns';

extend('required', { ...required, message: '{_field_} deve ser preenchido!' });
@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
  },
})
export default class CreateLeagueRoundTask extends Vue {
  @Prop({ type: Number }) readonly propLeagueTaskId;

  @Watch('propLeagueTaskId', { immediate: true })
  changePropLeagueTaskId(val) {
    this.clear();
    this.leagueTaskId = val;

    this.load();
  }

  public leagueTaskId = 0;
  public leagueRoundId = '';
  public name = '';
  public description = '';
  public periodStart = '';
  public periodEnd = '';
  public score = 0;
  public isChallenge = false;
  public isLoadingSave = false;

  public isValidPeriodStart = true;
  public isValidPeriodEnd = true;
  public dateRules = [
    (v) =>
      !v ||
      /^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|(([1][26]|[2468][048]|[3579][26])00))))$/g.test(
        v
      ) ||
      'Data é inválida',
  ];

  public async handleSaveLeagueTask() {
    this.isLoadingSave = true;

    if (this.leagueTaskId) {
      const updateLeagueTask: ILeagueTaskUpdate = {
        id: this.leagueTaskId,
        name: this.name,
        description: this.description,
        score: this.score,
        is_challenge: this.isChallenge,
        period_start: this.periodStart ? this.periodStart : undefined,
        period_end: this.periodEnd ? this.periodEnd : undefined,
      };

      await leagueTaskStore.updateLeagueTask({
        id: this.leagueTaskId,
        leaguetask: updateLeagueTask,
      });
    } else {
      const newLeagueTask: ILeagueTaskCreate = {
        league_round_id: this.leagueRoundId,
        name: this.name,
        description: this.description,
        score: this.score,
        is_challenge: this.isChallenge,
        period_start: this.periodStart ? this.periodStart : undefined,
        period_end: this.periodEnd ? this.periodEnd : undefined,
      };

      await leagueTaskStore.createLeagueTask({ leaguetask: newLeagueTask });
    }

    this.isLoadingSave = false;
  }

  public clear() {
    this.name = '';
    this.description = '';
    this.periodStart = '';
    this.periodEnd = '';
    this.score = 0;
    this.isChallenge = false;
  }

  public changeDate(strDate: string, type: string) {
    if (type === 'S') this.isValidPeriodStart = strDate === '' || false;
    else this.isValidPeriodEnd = strDate === '' || false;

    if (strDate === '' || !strDate) {
      if (type === 'S') {
        this.isValidPeriodStart = true;
        this.periodStart = '';
      } else {
        this.isValidPeriodEnd = true;
        this.periodEnd = '';
      }

      return;
    } else {
      let day = '';
      let month = '';
      let year = '';

      if (strDate.split('/').length === 3) {
        [day, month, year] = strDate.split('/');
      } else {
        strDate = strDate.replace('/', '');

        day = strDate.substr(0, 2);
        month = strDate.substr(2, 2);
        year = strDate.substr(4, 4);
      }

      const dateFormateUSA = `${year}-${month}-${day}`;

      if (type === 'S') {
        this.isValidPeriodStart = isValid(parseISO(dateFormateUSA));

        if (this.isValidPeriodStart) this.periodStart = dateFormateUSA;
      } else {
        this.isValidPeriodEnd = isValid(parseISO(dateFormateUSA));

        if (this.isValidPeriodEnd) this.periodEnd = dateFormateUSA;
      }
    }
  }

  public async load() {
    this.leagueRoundId = this.$route.params.leagueRoundId;

    if (!this.leagueTaskId) return;

    const leagueTask = leagueTaskStore.leagueTasks.find((item) => item.id === this.leagueTaskId);

    if (!leagueTask) return;

    this.name = leagueTask.name;
    this.description = leagueTask.description;
    this.isChallenge = leagueTask.is_challenge;
    this.score = leagueTask.score;

    if (leagueTask.period_start) this.periodStart = new Date(leagueTask.period_start).toISOString().substr(0, 10);

    if (leagueTask.period_end) this.periodEnd = new Date(leagueTask.period_end).toISOString().substr(0, 10);
  }
}
